export default __webpack_public_path__ + "static/media/our-store.b8a3e472.svg";